import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface LanguageSwitcherProps {
  className?: string;
}

const LANGS: { code: "fr" | "en" | "it"; label: string; aria: string }[] = [
  { code: "fr", label: "FR", aria: "Français" },
  { code: "en", label: "EN", aria: "English" },
  { code: "it", label: "IT", aria: "Italiano" },
];

const LanguageSwitcher = ({ className }: LanguageSwitcherProps) => {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const currentLang: "fr" | "en" | "it" = lang.startsWith("fr")
    ? "fr"
    : lang.startsWith("it")
      ? "it"
      : "en";

  const switchLang = (l: string) => {
    i18n.changeLanguage(l);
  };

  return (
    <div className={cn("flex items-center gap-1 font-display text-sm tracking-wider", className)}>
      {LANGS.map((l, i) => (
        <div key={l.code} className="flex items-center gap-1">
          {i > 0 && (
            <span className="text-foreground/70" aria-hidden="true">
              |
            </span>
          )}
          <button
            onClick={() => switchLang(l.code)}
            className={cn(
              "px-2 py-1 rounded transition-colors duration-200",
              currentLang === l.code
                ? "bg-sage text-primary-foreground"
                : "text-foreground/70 hover:text-foreground"
            )}
            aria-label={l.aria}
          >
            {l.label}
          </button>
        </div>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
